module.exports = __webpack_public_path__ + "static/media/bot.b0284ee0.ico";